import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import LoadingPage from './components/LoadingPage';
import HomePage from './components/HomePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

function App() {
  const [is_loading, set_is_loading] = useState(true);

  const handleLoadingComplete = () => {
    set_is_loading(false);
  };

  return (
    <div className="app">
      {is_loading ? (
        <LoadingPage onComplete={handleLoadingComplete} />
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
